
import { defineComponent } from 'vue';

export default defineComponent({
    name: "PersianDatePickerComponent",

    props: {
        placeholder: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            date: ''
        }
    }
})
